export interface CreativeApproachTemplate {
  category: string;
  sectionTitle: string;
  sectionDescription: string;
  bullets: string[];
}

export const CREATIVE_APPROACH_TEMPLATES: CreativeApproachTemplate[] = [
  {
    category: 'Product',
    sectionTitle: 'What is being shown',
    sectionDescription: 'The product, offer, or key value proposition',
    bullets: [
      'Defines core product characteristics',
      'Covers presentation and placement',
      'Includes usage and consumption context',
      'Organizes product-related elements',
    ],
  },
  {
    category: 'Structure',
    sectionTitle: 'How it is organized',
    sectionDescription: 'Layout, format, and visual hierarchy',
    bullets: [
      'Clear grid structure with sections',
      'Organized information hierarchy',
      'Sequential format with numbered steps',
      'CTA positioned at bottom',
    ],
  },
  {
    category: 'Story',
    sectionTitle: 'The narrative',
    sectionDescription: 'Journey, progression, and flow',
    bullets: [
      'Defines narrative and thematic elements',
      'Covers characters, settings, and context',
      'Includes events, occasions, and scenarios',
      'Guides storytelling direction',
    ],
  },
  {
    category: 'Graphics',
    sectionTitle: 'Visual design',
    sectionDescription: 'Colors, typography, and style',
    bullets: [
      'Defines visual and graphic elements',
      'Covers layout, colors, and branding',
      'Includes text placement and background',
      'Maintains visual clarity and consistency',
    ],
  },
  {
    category: 'Conceptual',
    sectionTitle: 'The idea',
    sectionDescription: 'Core message and emotional appeal',
    bullets: [
      'Defines high-level creative direction',
      'Covers messaging, tone, and atmosphere',
      'Includes various concept types',
      'Guides overall creative intent',
    ],
  },
];
